import { Collapse, Table } from "antd";
import { apiConfig } from "../product.config";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";

const TemplatePlaceholder = ({ userData, templateType }) => {
  const { session } = userData;
  const [isLoading, setIsLoading] = useState(false);
  const [fields, setFields] = useState(undefined);
  const [helpers, setHelpers] = useState(undefined);
  const [ghost, setGhost] = useState(null);
  const contractType = () => {
    switch (templateType) {
      case 1:
        return "TREASURY_BILL";
      case 2:
        return "BOND";
      case 3:
        return "FIXED_DEPOSIT";
    }
  };

  function formatLabel(text) {
    if (!text) return "";

    return (
      text
        // insert space before capital letters
        .replace(/([A-Z])/g, " $1")
        // handle acronyms/numbers better
        .replace(/\s+/g, " ")
        .trim()
        // capitalize first letter
        .replace(/^./, (str) => str.toUpperCase())
    );
  }

  const getTemplate = () => {
    setIsLoading(true);
    const url = `${apiConfig.certificates}/placeholders?contractType=${contractType()}`;
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err);
          setIsLoading(false);
        } else {
          const objList = res;
          setFields(objList.fields);
          setHelpers(objList.helpers);
          setIsLoading(false);
        }
      },
      "treasury",
    );
  };

  useEffect(() => {
    templateType && getTemplate();
  }, [templateType]);
  console.log(contractType(), templateType);

  if (fields)
    return (
      //   <Table
      //     size="small"
      //     bordered
      //     pagination={false}
      //     dataSource={rows}
      //     columns={[
      //       {
      //         title: "Field",
      //         dataIndex: "field",
      //         render: (text) => formatLabel(text),
      //         width: "35%",
      //       },
      //       {
      //         title: "Value",
      //         dataIndex: "value",
      //         // render: (value) => <JsonValue value={value} />,
      //         render: (value, record) => <div>{value}</div>,
      //       },
      //     ]}
      //   />

      <Collapse
        ghost={ghost}
        items={[
          {
            key: "1",
            label: "Allowed Template Parameters",
            children: (
              <Table
                columns={[
                  {
                    title: "Name",
                    dataIndex: "name",
                    render: (text) => text,
                    width: "35%",
                  },
                  {
                    title: "Description",
                    dataIndex: "description",
                    // render: (value) => <JsonValue value={value} />,
                    render: (value, record) => <div>{value}</div>,
                  },
                ]}
                dataSource={fields}
              />
            ),
          },
        ]}
        bordered={false}
        expandIconPosition={"end"}
        style={{ padding: "0px", marginBottom: 15, marginTop: 15 }}
        expandIcon={({ isActive }) => {
          isActive ? setGhost(false) : setGhost(true);
          return (
            <>
              {isActive ? (
                <MinusOutlined
                  style={{
                    backgroundColor: "#15CCAE",
                    color: "white",
                    padding: 8,
                    borderRadius: 10,
                  }}
                />
              ) : (
                <PlusOutlined
                  style={{
                    backgroundColor: "#15CCAE",
                    color: "white",
                    padding: 8,
                    borderRadius: 10,
                  }}
                />
              )}
            </>
          );
        }}
      />
    );
  return <></>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, null)(TemplatePlaceholder);
